import {getSessionToken} from 'utils/track';
import api from '../lib/api';

/**
 * Auth API
 * @param {string} method - Method
 * @param {string} path - Path
 * @param {object} opts - Options
 * @param {object} body - Body
 * @returns {Promise} Response
 */
function auth(method, path, opts = {}, body) {
	const sessionToken = getSessionToken();

	if (opts) {
		Object.assign(opts, {sessionToken});
	} else {
		opts = {sessionToken};
	}

	return api(method, `/auth/${path}`, opts, body);
}

const AuthActions = {
	getLogin() {
		return auth('get', 'login');
	},
	postLogin(loginObj) {
		return auth('post', 'login', null, loginObj);
	},
	logout() {
		return auth('post', 'logout');
	},
	changePassword(passObj, opts) {
		return auth('post', 'change-password', opts, passObj);
	},
	resetPassword(passObj) {
		return auth('post', 'reset-password', null, passObj);
	},
};

export default AuthActions;
